import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Tooltip from '../../components/Tooltip/Tooltip';
import Avatars from '../../components/Avatars/Avatars';
import Accordion from '../../components/Accordion/Accordion';
import FileInput from '../FileInput/FileInput.vue';
import Platforms from './Plaforms/Platforms';
import { mapActions, mapMutations, mapState } from 'vuex';
import MultiSelectSearch from '../MultiSelectSearch/MultiSelectSearch';
import moment from 'moment';
import Uploader from '@/utils/Uploader';
import { process } from '@/utils/Composer/Processors/LinkProcessor';

export default {
  name: 'Composer',
  components: {
    MultiSelectSearch,
    Platforms,
    Card,
    Button,
    Input,
    Tooltip,
    Avatars,
    Accordion,
    FileInput
  },
  props: [],
  data() {
    return {
      isExpanded: false,
      suggestArray: [
        [
          {
            if: 'theme',
            equals: 'group'
          }
        ]
      ],
      mediaUrl: null,
      mediaType: null,
      composer: {
        subject: null,
        variant: null,
        range: null,
        fileData: null,
        originalMeta: null,
        linkShouldProcess: true,
        content: {
          text: '',
          media: {
            url: null,
            type: null
          }
        },
        suggestFor: []
      }
    };
  },
  watch: {
    composer: {
      handler: function(val) {
        this._validate(val.content);
      },
      deep: true
    }
  },
  computed: {
    ...mapState('posts', ['newPost']),
    currentTime() {
      return moment().format('H:m:s');
    }
  },
  mounted() {},
  methods: {
    ...mapActions('posts', ['_validate', '_publishPost']),
    ...mapActions('groups', ['_getGroups']),
    ...mapActions('themes', ['_getThemes']),
    ...mapMutations('posts', ['_updateNewPost']),
    toggleExpanded: function() {
      var composerElement = document.getElementById('composer');
      var composerElementHeight = composerElement.offsetHeight;
      if (this.isExpanded) {
        document.getElementById('favorite-posts').style.paddingTop = '0px';
      } else {
        document.getElementById('favorite-posts').style.paddingTop = '16px';
      }
      this.isExpanded = !this.isExpanded;
    },
    showPreview: function(index) {
      this.activeAccountPreviewIndex = index;
    },
    schedulePost: function() {
      console.log(this.composer);
      //this._publishPost();
    },
    //Fetch multiple resources for multi select (depreciated)
    fetchChannels(params) {
      return new Promise((resolve, reject) => {
        Promise.all([this._getGroups(params), this._getThemes(params)]).then(
          values => {
            resolve([
              {
                group: 'Groups',
                values: values[0]
              },
              {
                group: 'Themes',
                values: values[1]
              }
            ]);
            //resolve(values);
          }
        );
      });
    },

    test() {
      console.log('ok');
    },

    // process(val.content.text).then(
    //   res => (this.composer.originalMeta = res)
    // );

    setUpload(value) {
      Uploader(value.target.files[0]).then(result => {
        this.mediaUrl = result.url;
        this.mediaType = result.type;

        this.composer.content.media.url = result.url;
        this.composer.content.media.type = result.type;
      });
    }
  }
};
